import { getDoc, setDoc } from './store';
import type { AbaId, Ajustes } from './types';

// Organizador da barra de baixo: o usuário fixa com um toque as abas que quer ver; as outras ficam só na tela "Abas".
// My Planner, Abas e Ajustes são fixos. Sem escolha salva, vale o padrão (as abas que já existiam antes da 0.18).
export const BARRA_PADRAO: AbaId[] = ['escritorio', 'scanner', 'pdfedit', 'anotacoes', 'casa', 'estudos', 'bemestar', 'financas', 'garantias', 'documentos', 'monitor'];
export const barraDe = (aj: Ajustes): AbaId[] => (aj.barra ?? BARRA_PADRAO).filter(id => id !== 'planner');
export const naBarra = (aj: Ajustes, id: AbaId) => id === 'planner' || barraDe(aj).includes(id);

export function alternarNaBarra(id: AbaId) {
  if (id === 'planner') return;
  setDoc('ajustes', d => {
    const b = barraDe(d);
    return { ...d, barra: b.includes(id) ? b.filter(x => x !== id) : [...b, id] };
  });
}
/** Move uma aba para a esquerda (-1) ou para a direita (+1) na barra. */
export function moverNaBarra(id: AbaId, dir: -1 | 1) {
  setDoc('ajustes', d => {
    const b = [...barraDe(d)];
    const i = b.indexOf(id), j = i + dir;
    if (i < 0 || j < 0 || j >= b.length) return d;
    [b[i], b[j]] = [b[j], b[i]];
    return { ...d, barra: b };
  });
}
export const restaurarBarra = () => setDoc('ajustes', d => ({ ...d, barra: undefined }));
export const barraAtual = () => barraDe(getDoc('ajustes'));
